// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import MobileNavigationController from "./mobile_navigation_controller"
application.register("navigation", MobileNavigationController)

import OffCanvasNavigationController from "./off_canvas_navigation_controller"
application.register("offcanvas", OffCanvasNavigationController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import TransitionController from "./transition_controller"
application.register("transition", TransitionController)

import ReceiptUploadController from "./receipt_upload_controller"
application.register("receipt-upload", ReceiptUploadController)

import FilterBarController from "./filter_bar_controller"
application.register("filter-bar", FilterBarController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import LlmProviderPingController from "./llm_provider_ping_controller"
application.register("llm-provider-ping", LlmProviderPingController)

import RoutingRuleModelController from "./routing_rule_model_controller"
application.register("routing-rule-model", RoutingRuleModelController)

import CsvImportMappingController from "./csv_import_mapping_controller"
application.register("csv-import-mapping", CsvImportMappingController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AmountModeController from "./amount_mode_controller"
application.register("amount-mode", AmountModeController)
